import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { moneyFormat } from '@helpers';
import { theme } from 'fpay-ui';
import { default as Icon } from './icon';
import { default as DetailedCard } from './DetailedCard';
import IconFalabella from './icon/iconFalabella';
import { default as Footer } from './Footer';
import { getEnv } from "@config";
import SimulationCredit from './SimulationCredit';

const { publicPath } = getEnv();

const BaseContainer = styled.div`
  width: 1016px;
  height: calc(100% - 198px);
  margin-top: 15px;
  display: flex;
  flex-direction: column;
  ${theme.breakpoint('sm', 'lg')} {
    width: 375px;
    height: auto;
    box-shadow: none;
    background-color: #fafafa;
  }
  align-items: center;
`;

const CardContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 784px;
  flex-wrap: wrap;
  justify-content: space-between;
  ${theme.breakpoint('sm', 'lg')} {
    width: auto;
    min-width: auto;
    flex-direction: column;
    padding: 0px;
  }
`;

const DetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 16px;
  margin-bottom: 8px;
  width: 290px;
`;

const DetailRow = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 8px;
  svg {
    height: 16px;
    width: 16px;
    margin-right: 8px;
  }
`;

const DetailText = styled.h1`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  margin: 0px;
  width: fit-content;
`;

const Image = styled.img`
  width: 40px;
  height: 40px;
`;

export const FinancialProduct = ({ financialOptionsAction, promotionsArray }) => {
  const { t } = useTranslation();
  const creditFacilityAmount = promotionsArray.find(
    (e) => e.product === 'CREDIT_FACILITY' && !(e.state === 'REJECTED')
  ).amount;
  const checkingCreditAmount = promotionsArray.find(
    (e) => e.product === 'CHECKING_CREDIT' && !(e.state === 'REJECTED')
  ).amount;
  const DetailedRow = ({ text }) => (
    <DetailRow>
      <Icon src="ic-financial-product-tick" width={15} height={15} />
      <DetailText>{text}</DetailText>
    </DetailRow>
  );

  const installments = (
    <DetailsContainer>
      <DetailedRow text={t('finance.financialProductSelection.installment.detail_1')} />
      <DetailedRow text={t('finance.financialProductSelection.installment.detail_2')} />
      <DetailedRow text={t('finance.financialProductSelection.installment.detail_3')} />
      <DetailedRow text={t('finance.financialProductSelection.installment.detail_4')} />
    </DetailsContainer>
  );

  const creditLine = (
    <DetailsContainer>
      <DetailedRow text={t('finance.financialProductSelection.creditLine.detail_1')} />
      <DetailedRow text={t('finance.financialProductSelection.creditLine.detail_2')} />
      <DetailedRow text={t('finance.financialProductSelection.creditLine.detail_3')} />
      <DetailedRow text={t('finance.financialProductSelection.creditLine.detail_4')} />
    </DetailsContainer>
  );

  return (
    <BaseContainer data-testId="multiple-financing-products">
      <CardContainer>
        <DetailedCard
          title={t('finance.financialProductSelection.installment.title')}
          subTitle={t('finance.financialProductSelection.installment.subtitle')}
          amount={`${moneyFormat(checkingCreditAmount, true)}`}
          details={installments}
          icon={<Image src={`${publicPath}/ic-financial-product-installments.svg`} alt="ic-financial-product-credit-line" />}
          buttonAction={() => financialOptionsAction('CHECKING_CREDIT_AVAILABLE')}
          buttonText={t('finance.financialProductSelection.installment.bottonText')}
          buttonId="loan-btn"
          disclaimer={t('finance.financialProductSelection.installment.disclaimer')}
          simulation={<SimulationCredit amountCredit={checkingCreditAmount} />}
        />
        <DetailedCard
          title={t('finance.financialProductSelection.creditLine.title')}
          subTitle={t('finance.financialProductSelection.creditLine.subtitle')}
          amount={`${moneyFormat(creditFacilityAmount, true)}`}
          details={creditLine}
          icon={<Image src={`${publicPath}/ic-financial-product-credit-line.svg`} alt="ic-financial-product-credit-line" />}
          buttonAction={() => financialOptionsAction('CREDIT_FACILITY_AVAILABLE')}
          buttonText={t('finance.financialProductSelection.creditLine.bottonText')}
          buttonId="credit-line-btn"
          disclaimer={t('finance.financialProductSelection.installment.disclaimer')}
        />
      </CardContainer>
      <Footer
        icon={<IconFalabella />}
        footerText={t('finance.financialProductSelection.footer')}
        urlText={t('finance.financialProductSelection.urlFooter')}
      />
    </BaseContainer>
  );
};
export default FinancialProduct;
